import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';

import {
  StyledContainer,
  Banner,
  Img,
  Content,
  Heading,
  Body,
  StyledCtas,
} from './styles';

const headingOption = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <Heading>{children}</Heading>;
    },
    [BLOCKS.HEADING_2]: (_, children) => {
      return <Heading>{children}</Heading>;
    },
  },
};

const BleedBanner = ({ data = null }) => {
  if (!data) return false;

  const { imageDam, bodyCopy, backgroundColor, heading, ctas } = data;

  return (
    <StyledContainer>
      <Banner bgColor={backgroundColor}>
        {bodyCopy && (
          <Content>
            {heading && <RichText document={heading} options={headingOption} />}
            {bodyCopy && (
              <Body>
                <RichText document={bodyCopy} />
              </Body>
            )}
            {ctas && <StyledCtas ctas={ctas} direction="row" />}
          </Content>
        )}
        {imageDam && <Img src={imageDam} alt={imageDam.altText || ''} />}
      </Banner>
    </StyledContainer>
  );
};

BleedBanner.propTypes = {
  data: PropTypes.shape(),
};

export default BleedBanner;
